import Metadata from '../../requests/apa/Metadata';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import Utils from 'src/utils/Utils';

let _playingCounter = 0;
let _avoidFallbackFirstTime = null;
let _appStartWithTvNode = null;

const FALLBACK_INTERVAL_TIME = 'fallback_interval_time';
const FALLBACK_INTERVAL_TIME_DEFAULT_VALUE = `{"default":{"seconds":15}}`;
const FIRST_TIME_FALLBACK_INTERVAL_TIME = 'first_time_fallback_interval_time';
const FIRST_TIME_FALLBACK_INTERVAL_TIME_DEFAULT_VALUE = `{"default":{"seconds":18}}`;
const FALLBACK_ERROR = 'fallback_error';
const FALLBACK_ERROR_DEFAULT_VALUE = `{"default":{"errors":["UmVzcG9uc2UgY29kZTogNTAz"], "enable":true}}`; // el item esta encodeado en base 64 y corresponde a Response code: 503

const getFallbackIntervalTime = (outputParams) => {
  let fallbackMetadataKey;
  let fallbackMetadataKeyDefaultValue;
  if(!fireFallback()){
    // it's first time
    fallbackMetadataKey = FIRST_TIME_FALLBACK_INTERVAL_TIME;
    fallbackMetadataKeyDefaultValue = FIRST_TIME_FALLBACK_INTERVAL_TIME_DEFAULT_VALUE;
  }
  else{
    fallbackMetadataKey = FALLBACK_INTERVAL_TIME;
    fallbackMetadataKeyDefaultValue = FALLBACK_INTERVAL_TIME_DEFAULT_VALUE;
  }

  const seconds = !outputParams.isLive ? Utils.getApaMetadataKey(fallbackMetadataKey, fallbackMetadataKeyDefaultValue, "seconds") : getDeviceIntervalTime(outputParams.streamType);
  return seconds * 1000;
}

const getDeviceIntervalTime = (streamType) =>{
  return Utils.getTimerFallBackDevice(streamType);
}

const getFallbackErrorList = () => {
  return Utils.getApaMetadataKey(FALLBACK_ERROR,FALLBACK_ERROR_DEFAULT_VALUE, "errors");
}

const getFallbackErrorEnable = () => {
  return Utils.getApaMetadataKey(FALLBACK_ERROR,FALLBACK_ERROR_DEFAULT_VALUE, "enable");
}


const isFallbackError = (error) => {
  const list = getFallbackErrorList();
  for(let i=0; i<list.length; i++){
    if(error.indexOf(list[i])!==-1){
      return true;
    }
  }
  return false;
}

const enableFallbackFirstTime = function() {
  if (_avoidFallbackFirstTime === null) {
    try {
      const meta = Metadata.get(
        'avoid_fallback_first_time',
        '{"default":{"enable":false}, "argentina":{"enable": true}, "colombia":{"enable":true}}'
      );
      const objectMeta = JSON.parse(meta);
      var _region = DeviceStorage.getItem('region');
      const value = objectMeta[_region] ? objectMeta[_region] : objectMeta['default'];
      if (value && typeof value == 'object' && value.enable) {
        _avoidFallbackFirstTime = value.enable;
      } else {
        _avoidFallbackFirstTime = false;
      }
    } catch (e) {
      _avoidFallbackFirstTime = false;
    }
  }

  return _avoidFallbackFirstTime;
};

const setStartWithTvNode = function(start) {
  if (enableFallbackFirstTime() && _appStartWithTvNode === null) {
    _appStartWithTvNode = start;
  }

  return _appStartWithTvNode;
};

const fireFallback = function() {
  let firef = true;
  if (enableFallbackFirstTime() && _appStartWithTvNode) {
    firef = _playingCounter > 1;
  }

  return firef;
};

const addPlaying = function() {
  if (enableFallbackFirstTime() && _appStartWithTvNode) {
    _playingCounter++;
  }
};

const FallbackHelper = {
  enableFallbackFirstTime,
  fireFallback,
  addPlaying,
  setStartWithTvNode,
  getFallbackIntervalTime,
  isFallbackError,
  getFallbackErrorEnable
};

export default FallbackHelper;



// WEBPACK FOOTER //
// ./src/AAFPlayer/helpers/FallbackHelper.js